import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "./assets/fonts.css";
import "./custom.css";
import { IMediaList, IMediaItem } from "./components/store/types";
import store from "./components/store";
import { play, pause } from "./components/store/actions/playerActions";
import { IPlayerState } from "./components/store/reducers/playerReducer";
import { getPlayer } from "./components/store/selectors/playerSelectors";
import { event } from "jquery";
import getCookie from "./components/utils/cookie-handler";

export const SLIDER_INIT_TYPES = {
  CONSTRUCTOR: "CONSTRUCTOR",
  PAGE_LOADED: "PAGE_LOADED",
};

const initSliders = (caller) => {
  const mainSliderConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
    appendArrows: ".slider .slide-arrows",
    appendDots: ".slider .slide-dots",
  };

  const speakersSliderConfig = {
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    appendArrows: ".speakers .slide-arrows",
    respondTo: "min",
    responsive: [
      {
        breakpoint: 1060,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const channelsSliderConfig = {
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    respondTo: "min",
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 1160,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 925,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 690,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    appendArrows: "div.channels-slider div div.slide-arrows",
  };
  const radioSliderConfig = {
    ...speakersSliderConfig,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  };
  $("#radioSlider").on("init", function (e, slick) {
    let activeIndex = $(".radio-slider-item").index(
      $(".radio-slider-item.active")
    );
    slick.slickGoTo(activeIndex);

    $("#radioSlider .radio-slider-item").on("click", async (event) => {
      event.preventDefault();
      const $this = $(this);
      if (!$this.attr("data-media-path")) return;
      $("#radioSlider .radio-slider-item.active").removeClass("active");
      $this.addClass("active");
    });
  });

  const call_sliders = () => {
    $("#radioSlider").slick(radioSliderConfig);
    $("#channelsSlider").slick(channelsSliderConfig);
    $("#speakersSlider").slick(speakersSliderConfig);
    $("#mainSlider").slick(mainSliderConfig);
  };

  switch (caller) {
    case SLIDER_INIT_TYPES.CONSTRUCTOR:
      document.addEventListener("DOMContentLoaded", function () {
        call_sliders();
      });
      break;

    case SLIDER_INIT_TYPES.PAGE_LOADED:
      call_sliders();
      break;

    default:
      call_sliders();
      break;
  }
};

const initElements = () => {
  $("#navToggle").on("click", function () {
    $(this).toggleClass("active");
    $(".top-nav-menu").toggleClass("open");
    // this line ▼ prevents content scroll-behind
    $("body").toggleClass("locked");
  });

  const copyRecentNewsChannelNameForMobileLayout = () => {
    const news = $(".recent-news-item");
    news.each((idx, el) => {
      const parent = $(el);
      const channelName = parent.find(".recent-news-channel-title").clone();
      const dateContainer = parent.find(".news-date");
      dateContainer.prepend(channelName);
    });
  };
  copyRecentNewsChannelNameForMobileLayout();
};

const buildList = (items: JQuery<HTMLElement>) => {
  const result: IMediaList = [];

  items.each((idx, item) => {
    const $item = $(item);

    const title = $item.data("media-title");
    const title_url = $item.data("media-title-url");
    const period_item_url = $item.data("media-period-item-url");
    let path = $item.data("media-path");
    let currentQuality = $item.data("media-current-quality");

    const pathVariants: string[][] | null = !$item.data("ch_live_url")
      ? null
      : [
          [
            $item.data("ch_live_url_aac"),
            $item.data("ch_live_url"),
            $item.data("ch_live_url_hq"),
          ],
          [
            $item.data("ch_live_url_s2_aac"),
            $item.data("ch_live_url_s2_lq"),
            $item.data("ch_live_url_s2_hq"),
          ],
          [
            $item.data("ch_live_url_s3_aac"),
            $item.data("ch_live_url_s3_lq"),
            $item.data("ch_live_url_s3_hq"),
          ],
          [
            $item.data("ch_live_url_default_aac"),
            $item.data("ch_live_url_default"),
            $item.data("ch_live_url_default_hq"),
          ],
          [
            $item.data("ch_live_url_default_s2_aac"),
            $item.data("ch_live_url_default_s2_lq"),
            $item.data("ch_live_url_default_s2_hq"),
          ],
          [
            $item.data("ch_live_url_default_s3_aac"),
            $item.data("ch_live_url_default_s3_lq"),
            $item.data("ch_live_url_default_s3_hq"),
          ],
        ];
    if ($item.attr("id") == "on-air-play-button") {
      let cookie_cq = getCookie("media-current-quality");
      if (cookie_cq) {
        switch (cookie_cq) {
          case "0":
            currentQuality = 0;
            path = $item.data("ch_live_url_aac");
            break;
          case "1":
            currentQuality = 1;
            path = $item.data("ch_live_url");
            break;
          case "2":
            currentQuality = 2;
            path = $item.data("ch_live_url_hq");
            break;

          default:
            break;
        }
      }
    }

    const metadata = $item.data("media-metadata");
    const description = $item.data("media-description");
    const picture = $item.data("media-picture");
    const channel = $item.data("media-channel");
    const date = $item.data("media-date");
    const time = $item.data("media-time");
    const playListNextItem = $item.data('media-playlist-next-item');
    const periodItemIndex = $item.data('media-period-item-index');
    const mediaItem: IMediaItem = {
      idx,
      title,
      title_url,
      period_item_url,
      channel,
      date,
      time,
      path,
      pathVariants,
      currentQuality,
      metadata,
      description,
      picture,
      playListNextItem,
      periodItemIndex,
      $element: $item,
      autoplayExcluded: false
    };

    result.push(mediaItem);
  });
  return result;
};

const initMedia = () => {
  const mediaContainers = $("*[data-media-container]");
  let cqe = $("#audio-element-player");
  let cqs = cqe.attr("data-current-quality");
  let currentQuality = Number(cqs);
  if (!currentQuality && currentQuality != 0) {
    let cookie_cq = getCookie("media-current-quality");
    if (cookie_cq) currentQuality = Number(cookie_cq);
  }
  if (currentQuality || currentQuality == 0) {
    $(".stream-switch").each(function (index) {
      if (index == currentQuality) $(this).addClass("active");
      else $(this).removeClass("active");
    });
  }
  $(".stream-switch").on("click", function () {
    $(".stream-switch").removeClass("active");
    $(this).addClass("active");
    $("#audio-element-player").attr(
      "data-current-quality",
      $(this).data("media-current-quality")
    );
    document.cookie =
      "media-current-quality=" +
      $(this).data("media-current-quality") +
      "; max-age=2678400; path=/";
  });

  mediaContainers.each((idx, container) => {
    const mediaItems = $(container).find("*[data-media-item]");
    const list = buildList(mediaItems);

    list.forEach((mediaItem, listID) => {
      mediaItem.$element.get(0).addEventListener(
        "click",
        (event) => {
          if ($(event.target).hasClass("not-audio-trigger")) {
            
          } else {
            event.preventDefault();
            let audio = $("#audio-element-player")[0] as HTMLAudioElement;
            if (audio.paused) {
              let playPromise = audio.play();
              playPromise.then(
                function (value) {},
                function (reason) {}
              );
            }
            const state: IPlayerState = getPlayer(store.getState());
            if (!mediaItem.path) {
              store.dispatch(pause());
              return;
            }
            if (mediaItem.$element.attr("data-forthcoming")) {
              store.dispatch(pause());
              return;
            }

            if (mediaItem.$element.hasClass("program-item-btn") && state.play) {
              if (state.current.path === mediaItem.path) {
                store.dispatch(pause());
              } else {
                store.dispatch(play(mediaItem, list, listID));
              }
            } else {
              store.dispatch(play(mediaItem, list, listID));
            }
          }
        },
        true
      );
    });
  });
};

const initTopScroll = () => {
  const upperLimit = 750; // pixels
  function initalizeTopScroll() {
    // Create a new MutationObserver
    const observer = new MutationObserver((mutationsList, observer) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "childList") {
          const playerContainer = document.querySelector(
            "#react-root .player-main.visible"
          ) as HTMLElement;
          const scrollBtn = document.querySelector(
            "#ukr-scroll-btn-up"
          ) as HTMLElement;
          if (playerContainer && scrollBtn) {
            let progressBar = document.querySelector(
              ".progress-wrapper"
            ) as HTMLElement;
            let pbHeight = progressBar
              ? progressBar.getBoundingClientRect().height
              : 0;
            scrollBtn.style.bottom =
              playerContainer.getBoundingClientRect().height +
              pbHeight +
              8 +
              "px";
            // Stop observing since the element is found
            // observer.disconnect();
          }
        }
      });
    });

    // Start observing the body for changes in the child elements
    observer.observe(document.body, { childList: true, subtree: true });

    const scrollToTopBtn = document.getElementById("ukr-scroll-btn-up");
    const bottomLimit = document.querySelector(".footer");

    if (scrollToTopBtn && bottomLimit) {
      window.addEventListener("scroll", function () {
        const bottomLimitOffset =
          bottomLimit.getBoundingClientRect().top + window.scrollY;
        const windowHeight = window.innerHeight;
        const scrollPosition = window.scrollY + windowHeight;
        if (window.scrollY > upperLimit && scrollPosition < bottomLimitOffset) {
          scrollToTopBtn.style.display = "block";
        } else {
          scrollToTopBtn.style.display = "none";
        }
      });

      scrollToTopBtn.addEventListener("click", function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    }
  }
  if (typeof $) {
    initalizeTopScroll();
  } else {
    window.addEventListener("load", function () {
      initalizeTopScroll();
    });
  }
};

export default (caller) => {
  initSliders(caller);
  initElements();
  initMedia();
  initTopScroll();
};
